import React, { useState } from 'react'

import { Column, Text } from 'Components/UI'

import { ChevronDownGlyph } from 'Assets/Svg/Icons'

import FaqSectionAccordionQuestion from './Question'
import { CollapseContainer, GroupButton } from './styles'

type Props = {
  content: {
    id: any
    question?: string
    answer?: string
  }[]
  title?: string
}

function FaqSectionAccordion({ content, title }: Props) {
  const [isUnfolded, setIsUnfolded] = useState(false)

  if (!title || !content?.length) return null

  return (
    <Column>
      <GroupButton
        unfolded={isUnfolded}
        onClick={() => setIsUnfolded(prevState => !prevState)}
      >
        <Text as="h3" body20 left medium title>
          {title}
        </Text>

        {ChevronDownGlyph()}
      </GroupButton>

      <CollapseContainer
        animate={{ height: isUnfolded ? 'auto' : 0 }}
        initial={{ height: 0 }}
      >
        <Column gap={7} pb={7}>
          {content.map(item => (
            <FaqSectionAccordionQuestion
              answer={item.answer}
              key={item.id}
              question={item.question}
            />
          ))}
        </Column>
      </CollapseContainer>
    </Column>
  )
}

export default FaqSectionAccordion
